import { EnumOrderType } from './Generated';
import { SelectOption } from '@synqo/frontend-component-library';

export function getOrderTypeLabel(type: EnumOrderType) {
    switch (type) {
        case EnumOrderType.Standard:
            return 'Standard';
        case EnumOrderType.Cash:
            return 'Barzahlung';
    }
}

export const orderTypeOptions: SelectOption<EnumOrderType>[] = [
    { name: 'standard', value: EnumOrderType.Standard, label: getOrderTypeLabel(EnumOrderType.Standard) },
    { name: 'cash', value: EnumOrderType.Cash, label: getOrderTypeLabel(EnumOrderType.Cash) },
];
